module.exports = __webpack_public_path__ + "img/tooltip_04-vallone-qoro-corian-cover.721f4c8c.jpg";